import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Tooltip } from '../elements-tooltip/tooltip-v2';
import withCustomInputHoc from './custom-input-hoc';
import { injectIntl, intlShape, defineMessages, FormattedMessage } from 'react-intl';
import 'moment/min/locales';
import DayPicker from 'react-day-picker';
import MomentLocaleUtils from 'react-day-picker/moment';
import 'react-day-picker/lib/style.css';

const translationMessages = defineMessages({
  startDatePlaceholder: {
    id: 'hosting.date_input_v2.form_placeholder_start_date',
    defaultMessage: 'start date'
  }
});
class DateOverlay extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      date: undefined,
      errorMsg: ''
    };
    this.captureDate = this.captureDate.bind(this);
  }

  captureDate (date, { disabled }) {
    if (disabled) return;

    const { getDate } = this.props;
    this.setState({ date }, () => {
      if (_.isFunction(getDate)) return getDate(date);
      return null;
    });
    this.tooltipComponent.externallyCloseTooltip();
  }

  anchorClickCB ({ open, showTooltip }) {
    showTooltip(!open);
  }

  render () {
    const { date } = this.state;

    const {
      calendarPlacement,
      htmlId,
      additionalInfo,
      placeholder,
      defaultDate,
      arrowPlacement,
      hasError,
      inputRef,
      country,
      intl
    } = this.props;

    const capturedDate = date || defaultDate;
    return (
      <div className="availability-container">
        <Tooltip
          id="day-picker"
          ref={ (ref) => { this.tooltipComponent = ref; }}
          placement={calendarPlacement || 'bottom'}
          tooltipClass="availability-popover"
          anchorClickCB={this.anchorClickCB}
          anchorType="custom"
          openCB={this.onDayPickerOpen}
          exitCB={this.onDayPickerExit}
          showX
          arrowPlacement={arrowPlacement}
          customAnchor={
            <div className="datepicker__input-container">
              <input
                ref={inputRef}
                type="text"
                id={htmlId}
                placeholder={placeholder || intl.formateMessage(translationMessages.startDatePlaceholder)}
                className="datepicker__input"
                readOnly
                data-value={capturedDate}
                value={capturedDate ? intl.formatDate(capturedDate, { year: 'numeric', month: 'short', day: 'numeric' }) : ''}
              />
            </div>
          }
          hideOnClickAnywhere
          shouldUpdatePosition
        >
          <div className="container-fluid text-center">
            <div className="row">
              <div className="col-xs-12">
                <DayPicker
                  fromMonth={new Date()}
                  onDayClick={this.captureDate}
                  className="availability-calendar"
                  month={capturedDate}
                  selectedDays={capturedDate}
                  disabledDays={[{ before: new Date() }]}
                  localeUtils={MomentLocaleUtils}
                  locale={_.get(intl, 'locale', 'us')}
                />
              </div>
            </div>
            {
              additionalInfo ?
                <div className="row">
                  <div className="col-xs-12">
                    <div className="additional-info text-center margin-lg-bottom">{additionalInfo}</div>
                  </div>
                </div>
                : null
            }
          </div>
        </Tooltip>
        {
          hasError && <p className="help-block inline-help text-danger text-left">
            <FormattedMessage
              id="hosting.date_input_v2.form_error_message"
              defaultMessage="Please enter a date"
            />
          </p>
        }
      </div>
    );
  }
}

DateOverlay.propTypes = {
  calendarPlacement: PropTypes.string,
  htmlId: PropTypes.string,
  additionalInfo: PropTypes.string,
  placeholder: PropTypes.string,
  defaultDate: PropTypes.instanceOf(Date),
  arrowPlacement: PropTypes.object,
  getDate: PropTypes.func,
  hasError: PropTypes.bool,
  inputRef: PropTypes.func,
  country: PropTypes.string,
  intl: intlShape.isRequired
};

const DateInput = withCustomInputHoc(injectIntl(DateOverlay));
export default DateInput;
